import clsx from 'clsx';
import { FC } from 'react';
import { Card } from '../Card';
import { VehiclePlate } from '../VehiclePlate';
import styles from './CarCard.module.css';
import { useIntl } from 'react-intl';

interface CarCardProps {
  vehicleName: string;
  driverName?: string;
  active?: boolean;
  className?: string;
  onClick?: () => void;
  fuelLevel: string;
  stateOfCharge: string;
  distanceUntilRecharge: string;
}

export const CarCard: FC<CarCardProps> = ({
  vehicleName,
  driverName,
  className,
  active,
  onClick,
  fuelLevel,
  stateOfCharge,
  distanceUntilRecharge,
}) => {
  const { $t } = useIntl();
  return (
    <Card
      onClick={onClick}
      className={clsx(styles.carCard, className, { [styles.active]: active })}
      data-testid="car-card"
    >
      <div className={styles.carCardTitle}>
        <VehiclePlate active={active}>{vehicleName}</VehiclePlate>
        <div className={styles.circle} />
      </div>
      <div className={styles.driverName}>
        {driverName ? driverName : $t({ id: 'Vehicle.Info.NoDriver' })}
      </div>
      {fuelLevel && parseInt(fuelLevel) > 0 && (
        <div>
          {$t({ id: 'Vehicle.Info.FuelLevel' })} {Number(fuelLevel).toFixed(1)}l
        </div>
      )}
      {stateOfCharge && (
        <div>
          {$t({ id: 'Vehicle.Info.StateOfCharge' })} {parseInt(stateOfCharge)}%
        </div>
      )}
      {distanceUntilRecharge && (
        <div>
          {$t({ id: 'Vehicle.Info.DistanceUntilRecharge' })}{' '}
          {parseInt(distanceUntilRecharge)}km
        </div>
      )}
    </Card>
  );
};
